module.exports = __webpack_public_path__ + "img/access_wallet_icon.815c1d73.svg";